/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"

import { getMentalSkillsDashboardResults } from "../../../requesters/CalculatorResultsRequester"
import WellbeingIndexChart from "../WellbeingIndexChart"
import IndexGauge from "../IndexGauge"
import MentalSkillsBreakdownCard from "./MentalSkillsBreakdownCard"
import { getMentalSkillsOverallDesc } from "./constants"
import { OVERVIEW_PAGE_CONTENT } from "../constants"
import { getAssetPath } from "../../../utils/assets"

function Dashboard({ baseUrl, currentUser }) {
  const [surveyResults, setSurveyResults] = useState([])
  const [wellbeingIndexes, setWellbeingIndexes] = useState([])
  const [recommendations, setRecommendations] = useState({})
  const [inflight, setInflight] = useState(true)
  const unfinishedSurveyExists = currentUser.active_enrolment.is_new_attempt_mental_skills

  useEffect(() => {
    document.title = "Performance Intelligence Academy | Mental Skills Dashboard"
  }, [])

  const fetchResults = useCallback(() => {
    getMentalSkillsDashboardResults(baseUrl, currentUser).then(res => {
      if (res.response.json?.calculator_results) {
        const recentResults = res.response.json?.calculator_results
        setSurveyResults(res.response.json?.calculator_results)
        setRecommendations(res.response.json?.calculator_results[0]?.recommendations)
        setWellbeingIndexes(recentResults.map(result => result.wellbeing_index))
      }
      setInflight(false)
      return null
    }).catch(err => {
      setInflight(false)
      // eslint-disable-next-line no-console
      console.log(err)
    })
  }, [baseUrl, currentUser])

  useEffect(() => {
    fetchResults()
  }, [fetchResults])

  if (inflight) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  // // Route to linking code page when User not enrolled in a program
  if (!currentUser?.active_enrolment) {
    window.location.href = "/overview"
  } else if (!surveyResults?.length && !inflight) {
    window.location.href = "/overview"
  }

  return (
    <div className="dashboard-body">
      <div className="content">
        <div className="container dashboard" id="dashboard-10dwc">
          <div className="d-flex align-items-center justify-content-between py-4">
            <div>
              <Link
                to="/overview"
                className="back-to-overview">
                <img src={getAssetPath("icn-back")} />
              </Link>
              <img src={getAssetPath(OVERVIEW_PAGE_CONTENT.mental_skills.logoAssetName)} />
            </div>
            <div className="start-survey">
              <Link className="btn btn-main ml-4" to="/mental-skills/intro">{`${unfinishedSurveyExists ? "Start" : "Continue"} Survey`}</Link>
              <div className="small">{`Last completed on ${surveyResults[0]?.completed_at}`}</div>
            </div>
          </div>
          <div className="dash-row row wellness-index">
            <div className="col-lg-4">
              <div className="card">
                <div className="card-body">
                  <div className="pre-text">Your Mental Skills Score</div>
                  <div className="gauge">
                    <IndexGauge
                      category={surveyResults[0]?.wellbeing_index_category}
                      color={surveyResults[0]?.wellbeing_index_color}
                      index={surveyResults[0]?.wellbeing_index} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="pre-text">Your Mental Skills Score Trend</div>
                  <WellbeingIndexChart results={surveyResults} />
                </div>
              </div>
            </div>
          </div>
          <div className="dash-row row">
            <div className="col-lg-4"><Link className="btn btn-lg-block bg-main" to="/about-mental-skills">What is MSC?</Link></div>
            {currentUser.active_enrolment?.mental_skills_latest_submitted_id && (
              <div className="col-lg-8">
                <a
                  className={`btn btn-lg-block btn-outline-main${surveyResults[0]?.download_pdf_url ? "" : " disabled"}`}
                  target="_blank"
                  rel="noreferrer"
                  href={surveyResults[0]?.download_pdf_url || undefined}
                  aria-disabled={!surveyResults[0]?.download_pdf_url}
                  tabIndex={surveyResults[0]?.download_pdf_url ? undefined : -1}
                  onClick={e => { if (!surveyResults[0]?.download_pdf_url) e.preventDefault() }}>
                  {/* TODO: add the download icon */}
                  Download Latest Report
                </a>
              </div>
            )}
          </div>
          <MentalSkillsBreakdownCard surveyResults={surveyResults} />

          <div className="dash-row recommendations">
            <div className="row">
              <div className="col-xl-3">
                <div className="pre-text">How to improve</div>
                <h3>Recommendations</h3>
                <div className="mb-3">
                  {getMentalSkillsOverallDesc(wellbeingIndexes[0] || 0)}
                </div>
              </div>
              {
                  !!recommendations.length && recommendations.map(recommendation => (
                    <div className="col-xl-3" key={recommendation.heading}>
                      <div className="card recommendations-item">
                        <div className="card-body">
                          <div className="mb-1">
                            <small>{recommendation.section}</small>
                          </div>
                          <h6 className="mb-3 recommendations-header">{recommendation.heading}</h6>
                          <ul>
                            {recommendation.content.map((text, index) => (
                              // eslint-disable-next-line react/no-array-index-key
                              <li key={`${text.slice(0, 3)}-${index}`}>{text}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))
                }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
